module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABE0lEQVQ4jXWT0Y3FIAwEx6f0hTvDdGYq2/sAkhD0LKEIx17YAUwS32itHclaqx2FgL0FVqO7U0rBDIgGQPwSkoQkIkKSlJmSJJAIzkFo9UgaO2itqdZK7x3PfK33IwIkGcC1cr13SimQPoteGMKm6Cl8tda0PPfeUdXwDsTyf/QKM5Mku72vWN5XnskFGP+QiNDAJ4iIG1xmKjPP5kPkEbgAPJP8eDMge8dLub8j2lb39564l3kKZ3P2PqvqDnHiwn1Sj4pnJ+eubhF3IgJoA+rNU8POuCR6gRogh+8HqkAx/U/mYkDROeIFLWI0sovcV3IXCT3z2HJfke0xmZ2v8IlYlq2Zqc6T2gQeITuS6+5/a/4B1WdLKOGVz1MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/IEXPLORE_16.png
// module id = 79
// module chunks = 0